module.exports = __webpack_public_path__ + "img/user-viajes-1.37e56a94.svg";